import { useDispatch } from 'react-redux';
import './MobileControls.scss';
import { selectScene } from 'src/app/redux/slice/sceneSlice';

const MobileControls = ({ prev, next }) => {
  const dispatch = useDispatch();
  const changeScene = (scene) => {
    dispatch(selectScene(scene));
  };
  console.log(prev, next);
  return (
    <div className="scroll-controls">
      {prev && (
        <button onClick={() => changeScene(prev)} aria-label="Previous">
          <div className="scroll-prev"></div>
        </button>
      )}
      {prev && next && <span className="scroll-controls-split"></span>}
      {next && (
        <button onClick={() => changeScene(next)} aria-label="Next">
          <div className="scroll-next"></div>
        </button>
      )}
    </div>
  );
};

export default MobileControls;
